import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slices/UserSlice'
import AlertSlice from './slices/AlertSlice'
import QrSlice from './slices/QrSlice'
import ActSlice from './slices/ActSlice'
import AdminSlice from './slices/AdminSlice'
import CollectiveSlice from './slices/CollectiveSlice'
import ProjectSlice from './slices/ProjectSlice'
import PersonalCard from './slices/PersonalCard'
export const store = configureStore({
  reducer: {
    user: userReducer,
    qr: QrSlice,
    alert: AlertSlice,
    act: ActSlice,
    admin: AdminSlice,
    collective: CollectiveSlice,
    project: ProjectSlice,
    personalcard: PersonalCard,
  },
})
